module.exports = __webpack_public_path__ + "img/f3_2.63533dec.png";